export default "/kiban/_next/static/images/02_2L_alm_base-b2f8021d038c87a5ef05a8aee2f107fb.png";